import script from "./inline-link.vue?vue&type=script&setup=true&lang=ts"
export * from "./inline-link.vue?vue&type=script&setup=true&lang=ts"

import "./inline-link.vue?vue&type=style&index=0&id=7e3b4e80&lang=scss"

const __exports__ = script;

export default __exports__